import VueCountdown from '@chenfengyuan/vue-countdown'
import Vue from 'vue'

Vue.component(VueCountdown.name, VueCountdown)
